import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import DinoInterceptor from './dino-components/DinoInterceptor';
import { ThunkDispatch } from 'redux-thunk';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { logoutUser } from '../store/user/user.actions';
import { GalaxyToast } from '@dinocloud/galaxy-components-lib';

interface LinkDispatchProps {
  // @ts-ignore implicit-any
  logoutUser: () => void;
}
type Props = RouteComponentProps & LinkDispatchProps;

class Interceptors extends React.Component<Props> {
  render() {
    return (
      <DinoInterceptor baseUrl={process.env.REACT_APP_API_HOST}>
        <DinoInterceptor.Unauthorized
          action={async () => {
            await this.props.logoutUser();
            this.props.history.push('/login');
            GalaxyToast({
              header: 'La sesión expiró',
              message: 'Vuelva a iniciar sesión',
              type: 'info',
            });
          }}
        />
      </DinoInterceptor>
    );
  }
}

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, any>
): LinkDispatchProps => ({
  logoutUser: bindActionCreators(logoutUser, dispatch),
});

export default withRouter(connect(null, mapDispatchToProps)(Interceptors));
